const Menu = [
  { path: '/events', icon: 'fa fa-calendar', title: 'Events' },
  { path: '/checkmate', icon: 'fa fa-building', title: 'Milo Checkmate' },
  { path: '/contact', icon: 'fa fa-phone', title: 'Contact Information' },
  { path: '/archive', icon: 'fa fa-landmark', title: 'Historical Events' },
  { path: '/tournaments', icon: 'fa fa-chess', title: 'Youth Standard Open' },
  { path: '/tournaments2', icon: 'fa fa-chess-board', title: '1st leg MCC Invitational Standard Open Training Games' },
  { path: '/score-sheet', icon: 'fa fa-chess-knight', title: 'Score Sheet' },
]

export default Menu;